import { TenantThemeOverrideMode } from 'src/app/base/services/theme.model';
import { ThemeTokenOverrideRow } from './theme-token-override.util';

export interface ThemeTokenOverrideActionResolution {
  action: 'add' | 'update';
  targetRow?: ThemeTokenOverrideRow;
}

/**
 * Shared rules for deciding whether a theme token override should be added as a new
 * row or update an existing one for a given (variable, mode) pair. Used by both the
 * full override editor grid and the quick docked editor so the add/update behavior
 * stays consistent across both UIs.
 */
export function getThemeTokenOverrideRowsForVariable(rows: ThemeTokenOverrideRow[], variable: string): ThemeTokenOverrideRow[] {
  return rows.filter((row) => row.variable === variable);
}

export function resolveThemeTokenOverrideAction(
  rows: ThemeTokenOverrideRow[],
  variable: string,
  mode: TenantThemeOverrideMode
): ThemeTokenOverrideActionResolution {
  const existingRows = getThemeTokenOverrideRowsForVariable(rows, variable);
  const exactMatch = existingRows.find((row) => row.mode === mode);
  return exactMatch ? { action: 'update', targetRow: exactMatch } : { action: 'add' };
}

export function resolveThemeTokenOverrideValueForSelection(
  rows: ThemeTokenOverrideRow[],
  variable: string,
  mode: TenantThemeOverrideMode
): string {
  const resolution = resolveThemeTokenOverrideAction(rows, variable, mode);
  return resolution.action === 'update' && resolution.targetRow ? resolution.targetRow.value : '';
}
